import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const SectionHeader = ({ title }) => {
  return <Header> {title} </Header>;
};

const Header = styled(motion.h2)`
  position: absolute;
  font-size: 10rem;
  opacity: 0.15;
  letter-spacing: 0.3rem;
  background-image: linear-gradient(45deg, #ab24f3, rgb(109, 232, 251));
  background-size: 100%;
  background-repeat: repeat;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -moz-background-clip: text;
  -moz-text-fill-color: transparent;
  font-family: "Work Sans", sans-serif;
  filter: brightness(1.2);

  @media (max-width: 900px) {
    padding-bottom: 2.5rem;
    padding-top: 0rem;
    padding-left: 0rem;
    position: relative;
    display: flex;
    font-size: 1.3rem;
    opacity: 1;
  }
`;

export default SectionHeader;
